module.exports = __webpack_public_path__ + "static/media/large.90099a7e.jpg";